export default "__VITE_ASSET__D8wGK7xo__"